import { FC } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

export interface SidebarProps extends FlexProps {
  isScrollable?: boolean;
}

const Sidebar: FC<SidebarProps> = ({ isScrollable, ...props }) => (
  <Flex
    alignItems="stretch"
    flexDirection="column"
    width="360px"
    {...(isScrollable && {
      maxHeight: '100vh',
      overflowY: 'auto',
    })}
    {...props}
  />
);

export default Sidebar;
